var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBackArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13865 11.0006L11.4979 18.3598C12.1674 19.0293 12.1674 20.1147 11.4979 20.7842C10.8284 21.4536 9.743 21.4536 9.07353 20.7842L0.502102 12.2127C-0.167368 11.5433 -0.167368 10.4578 0.502102 9.78837L9.07353 1.21695C9.743 0.547476 10.8284 0.547476 11.4979 1.21695C12.1674 1.88642 12.1674 2.97184 11.4979 3.64131L4.13865 11.0006Z",
    fill: "#82878D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBackArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/back-arrow.8f4f930d.svg";
export { ForwardRef as ReactComponent };